import React, {useState, useEffect, useContext, useRef} from "react";
import EncodingService from '../api/encoding/EncodingService.js'
import Navigation from "../Navigation";
import NavbarISO from "../NavbarISO";
import Header from "../Header";
import Footer from "../Footer";
import axios from 'axios';
import {Button, ProgressIndicator, Table} from '@veneer/core';
import {AuthContext} from "../auth/AuthContext";
import Notices from "../components/Notices";
import VerifyInstructions from "../components/VerifyInstructions";
import {AUTHENTICATED, removeLocalStorageItem} from "../utils/storage-utils";

const SWDownload = (props) => {

    const tabsEnabledStatus = 'FULL';
    const {uiAccess} = useContext(AuthContext);
    const [softwareData, setSoftwareData] = useState([]);
    const [downloadError, setDownloadError] = useState([]);
    const [preSignedURL, setPreSignedURL] = useState("");
    const [softwareFile, setSoftwareFile] = useState("");
    const [showProgressBar, setShowProgressBar] = useState(false);
    const [downloadPercentage, setDownloadPercentage] = useState(0);
    const [downloadFinished, setDownloadFinished] = useState(false);
    const [url, setUrl] = useState('');
    const [download, setDownload] = useState('');
    const [showDownload, setShowDownload] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [loading, setLoading] = useState(false);


    const downloadRef = useRef(null)

    let role = props.role;

    useEffect(() => {
        getSoftwareFunction();
    }, []);

    useEffect(() => {
        if (preSignedURL !== "" && softwareFile !== "") {
            getFileFromS3(preSignedURL, softwareFile);
        }
    }, [preSignedURL, softwareFile]);

    const getSoftwareFunction = async () => {
        setLoading(true);
        try {
            const res = await EncodingService.getAllSoftwares();
            setSoftwareData(res?.data);
        } catch (error) {
            setDownloadError(["Error fetching software data.", "Please try again later."]);
            removeLocalStorageItem(AUTHENTICATED);
            window.location.href ="/supplyencodingsvc/?state=Error";
        } finally {
            setLoading(false);
        }
    };

    const getS3PreSignedURL = async (swFile) => {
        try {
            const res = await EncodingService.getS3PreSignedURLForDownload(swFile);
            return res?.data.message;
        } catch (error) {
            setDownloadError(["Error downloading file " + swFile + ".", "Please try again later."]);
        }
    };

    const getFileFromS3 = async (URL, swFile) => {
        setShowProgressBar(true);
        try {
            const res = await axios({
                url: URL,
                method: "GET",
                responseType: "blob",
                onDownloadProgress: (progressEvent) => {
                    let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setDownloadPercentage(percentCompleted);
                }
            });
            const blob = new Blob([res.data]);
            let fileUrl = window.URL.createObjectURL(blob);
            setUrl(fileUrl);
            setDownload(swFile);
            setShowDownload(true);
            downloadRef.current.click();
            setDownloadError([]);
            setDownloadFinished(true);
            setTimeout(() => {
                setDownloadFinished(false);
            }, 2000);
        } catch (error) {
            setDownloadError(["Error downloading file " + swFile + ".", "Please try again later."]);
        } finally {
            setShowProgressBar(false);
        }
    };

    const downloadSWFile = async (swFile) => {
        try {
            setShowProgressBar(true);
            setSoftwareFile(swFile);
            setPreSignedURL('');
            setDownloadFinished(false);
            setDownloadPercentage(0);
            setDownloadError([]);

            const url = await getS3PreSignedURL(swFile);
            setPreSignedURL(url);

            // Trigger download process using preSignedURL
            console.log('Downloading SW file:', swFile);
            // Implement download logic here using preSignedURL
        } catch (error) {
            console.error('Error downloading SW file:', error);
            setDownloadError(prevErrors => [...prevErrors, error.message]);
            setShowProgressBar(false);
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePageSizeChange = (event, option) => {
        setPageSize(option.value);
    };

    return (
        <div>
            <Header/>
            {uiAccess.navbarISO && <NavbarISO role={role}/>}
            {uiAccess.navigation && <Navigation tabsEnabledStatus={tabsEnabledStatus} role={role}/>}
            <Notices/>
            <div className="tableWrapper">
                <div className="row justify-content-start">
                    <div className="col-md-12">
                        <div className="title p-50">
                            <h5 className="subtitle-large">Download Files</h5>
                        </div>
                        {(showProgressBar === false && downloadFinished === false) ? (
                                    <div className="col-md-17">
                                        <Table
                                            id={'account'}
                                            loading={loading}
                                            columnResize={false}

                                            columns={[
                                                {
                                                    id: 'softwareName',
                                                    label: 'Title',
                                                },
                                                {
                                                    id: 'swVersionAvailable',
                                                    label: 'File name',
                                                },
                                                {
                                                    id: 'swSize',
                                                    label: 'File Size',
                                                },
                                                {
                                                    id: 'fileCreateDateTime',
                                                    label: 'Created Date',
                                                },
                                                {
                                                    id: 'downloadFile',
                                                    label: "Download File",
                                                },
                                                {
                                                    id: 'downloadSignatureFile',
                                                    label: "Download Signature",
                                                },
                                                {
                                                    id: 'downloadPublicKeyFile',
                                                    label: "Download Public Key",
                                                }
                                            ]}
                                            data={
                                                softwareData ? softwareData.map((data) => {
                                                        return {
                                                            softwareName: data.name,
                                                            swVersionAvailable: data.swFileName,
                                                            fileCreateDateTime: data.fileCreateDateTime,
                                                            swSize: data.size,
                                                            downloadFile: <Button id={"download/" + data.id} small={true}
                                                                                  onClick={() => downloadSWFile(data.swFileName)}
                                                                                  appearance="secondary"> File</Button>,
                                                            downloadSignatureFile: <Button id={"download/" + data.id}
                                                                                           small={true}
                                                                                           onClick={() => downloadSWFile(data.signature_fileName)}
                                                                                           appearance="secondary"
                                                                                           disabled={!data.signature_fileName}> Signature</Button>,
                                                            downloadPublicKeyFile: <Button id={"download/" + data.id}
                                                                                           small={true}
                                                                                           onClick={() => downloadSWFile(data.public_key_fileName)}
                                                                                           appearance="secondary"
                                                                                           disabled={!data.public_key_fileName}> PublicKey</Button>
                                                        }
                                                    }).slice((currentPage - 1) * pageSize,
                                                        (currentPage - 1) * pageSize + pageSize)
                                                    : []
                                            }
                                            pagination={{
                                                currentPage: currentPage,
                                                pageSizeOptions: softwareData.length <= 2 ? [{value: softwareData.length}] :
                                                    softwareData.length < 5 ? [{value: 2}, {value: softwareData.length}] :
                                                        softwareData.length <= 8 ? [{value: 2}, {value: 4}, {value: softwareData.length}] :
                                                            softwareData.length <= 9 ? [{value: 2}, {value: 4}, {value: 8}, {value: softwareData.length}] :
                                                                softwareData.length <= 10 ? [{value: 2}, {value: 4}, {value: 8}, {value: softwareData.length}] : [{value: 2}, {value: 4}, {value: 8}, {value: 10}, {value: softwareData.length}],
                                                onPageChange: handlePageChange,
                                                onPageSizeChange: handlePageSizeChange,
                                                totalItems: softwareData.length,
                                                pageSize: pageSize
                                            }}
                                        />
                                </div>
                            ) :
                            (
                                <div className="p-l-0">
                                    {showProgressBar && <p className="p-l-0 c-b"> Downloading {softwareFile} </p>}
                                    {showProgressBar &&
                                        <ProgressIndicator className="progress-indicator" appearance="linear"
                                                           behavior="determinate" value={downloadPercentage}
                                                           showLabel/>}
                                    {downloadFinished &&
                                        <p className="p-l-0 c-b"> Downloaded {softwareFile} successfully </p>}
                                </div>
                            )
                        }
                        {downloadError && (<div>
                            <p className="p-l-0 c-r">
                                {downloadError[0]}
                            </p>
                            <p className="p-l-0 c-r">
                                {downloadError[1]}
                            </p>
                        </div>)}
                    </div>
                    {showDownload && <a href={url} download={download} ref={downloadRef}> </a>}
                </div>
            </div>
            <br></br>
            <VerifyInstructions/>
            <Footer/>
        </div>
    );
}

export default SWDownload;